import React from "react";
import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { Translate } from "react-redux-i18n";

import "./styles/RegisterSuccessfull.css";

class PasswordResetSuccessfull extends React.Component {
  render() {
    return (
      <div className="register-success-page">
        <div className="register-success-card">
          <div className="register-success-card__icon" aria-hidden="true">
            <FaCheckCircle />
          </div>

          <h1 className="register-success-card__title">
            <Translate value="password_change" />
          </h1>

          <p className="register-success-card__text">
            <Translate value="password_reset_success" />
          </p>

          <Link to="/login" className="register-success-card__button">
            <Translate value="login" />
          </Link>
        </div>
      </div>
    );
  }
}

export default PasswordResetSuccessfull;
